import React from 'react';
import './browse_delivery_method.less';
import LoggedinFooter from '../footer/loggedin_footer';
import InputComponent from '../components/input_component/input_component';
import {Link, browserHistory} from 'react-router';
import ShipmentDetailsSection from './shipment_details_section';
import MediaQuery from 'react-responsive';
import {commonFunctions} from './browser_common';
import SendMessagePopup from './send_message_popup/send_message_popup.jsx';
import CONSTANTS from '../common_constants';

import ShowError from '../components/error/show_error';
import validate from '../util/validate';
import {join} from '../util/common';

import browsePackagesAction from './browser_packages_actions';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

class DeliveryComponentFlight extends React.Component{
 constructor(props){
   super(props);
   this.state = {
     offerData: this.props.offerData,
     error: ''
   }
 }

 addTransportationDetails = () => {
   let validationErrorMsg = '';

   let validationError;

   let validationMap;

   validationMap = {
       flightNo: 'Flight Number'
   };

   let offerDataState = this.state.offerData;

   const offerData = Object.assign({}, offerDataState);

   if(!offerData.hasOwnProperty('flightNo')){
     offerData.flightNo = null;
   }



   validationError = {
       flightNo: !validate.name(offerData.flightNo)
   };

   const validationFields = [];

   Object.keys(validationError).forEach((key) => {
       if (validationError[key]) {
           validationFields.push(validationMap[key]);
       }
   });

   if (validationFields.length) {
       validationErrorMsg = 'Please enter the ' + join(validationFields, (item, idx) => {
           if (validationFields.length === 1)
               return "";
           if (idx > 0 && idx < validationFields.length - 1)
               return ", ";
           else if (idx === validationFields.length - 1)
               return " and ";
           return "";
       }) + '.';
   }

   if (validationErrorMsg) {
       this.setState({error: validationErrorMsg},
         this.props.updateParentState(this.state.offerData, validationErrorMsg)
       );
       return;
   }else{
     this.props.updateParentState(this.state.offerData, null);
   }

 }

 componentDidMount(){
   const offerData = Object.assign({}, this.props.offerData);
   if(!offerData.hasOwnProperty('flightNo')){
     offerData.flightNo = null;
     this.setState({
       offerData
     })
   }
 }

 componentWillReceiveProps(newProps){
   this.setState({
     offerData: newProps.offerData
   })
 }

 getInputValue = (inputName, value) => {

   let inputArr = inputName.split('.');
   let offerData = Object.assign({},this.state.offerData);


   if(inputArr[1] == 'car'){
     offerData.car[inputArr[2]] = value;
   }else{
     offerData[inputArr[1]] = value;
   }

   this.setState({
     offerData
   })

 }

 render(){
   return(
     <div>
       <div className="transporation-form">
          <InputComponent type={'text'} value={validate.isEmpty(this.state.offerData) ? "" : this.state.offerData.flightNo} title={'Enter your flight number so we can track your flight progress.'} placeholder={'Flight Number'} changeHandler = {this.getInputValue} dollar={false} for='offerData.flightNo' />
        </div>
       <button id="deliveryDetails" className="btn orange" onClick={this.addTransportationDetails}>Next</button>
     </div>
   )
 }
}


class DeliveryComponentCar extends React.Component{
 constructor(props){
   super(props);
   this.state = {
     offerData: this.props.offerData,
     error: ''
   }
 }

 addTransportationDetails = () => {

   let validationErrorMsg = '';
   let validationError;
   let validationMap;
   validationMap = {
      make: 'Make of Car',
      model: 'Model of Car',
      color: 'Color of Car'
  };

   if (validationErrorMsg) {
       this.setState({error: validationErrorMsg},
         this.updateParentState(this.state.orderData, validationErrorMsg)
       );
       return;
   }

   validationError = {
       make: !validate.name(this.state.offerData.car.make),
       model: !validate.name(this.state.offerData.car.model),
       color: !validate.name(this.state.offerData.car.color)
   };

   const validationFields = [];

   Object.keys(validationError).forEach((key) => {
       if (validationError[key]) {
           validationFields.push(validationMap[key]);
       }
   });

   if (validationFields.length) {
       validationErrorMsg = 'Please enter the ' + join(validationFields, (item, idx) => {
           if (validationFields.length === 1)
               return "";
           if (idx > 0 && idx < validationFields.length - 1)
               return ", ";
           else if (idx === validationFields.length - 1)
               return " and ";
           return "";
       }) + '.';
   }

   if (validationErrorMsg) {
       this.setState({error: validationErrorMsg},
         this.props.updateParentState(this.state.orderData, validationErrorMsg)
       );
       return;
   }else{
     this.props.updateParentState(this.state.offerData, null);
   }

 }

 componentDidMount(){
   let offerData = Object.assign({},this.state.offerData);
   if(!offerData.hasOwnProperty('car')){
     offerData.car = {}
     this.setState({
       offerData
     })
   }
 }

 componentWillReceiveProps(newProps){
   this.setState({
     offerData: newProps.offerData
   })

 }

 getInputValue = (inputName, value) => {
   let inputArr = inputName.split('.');
   let offerData = Object.assign({},this.state.offerData);
   let car = {};
   ( validate.isEmpty(offerData.car) ? car = offerData.car : (car = car) );

   if(inputArr[1] == 'car'){
     offerData.car[inputArr[2]] = value;
   }else{
     offerData[inputArr[1]] = value;
   }

   this.setState({
     offerData
   })

 }

 render(){
   let {offerData} = this.state;

   return(
     <div>
       <div className="transporation-form">
          <InputComponent value = { (offerData && validate.isEmpty(this.state.offerData.car) )? "" : this.state.offerData.car.make} type={'text'} title={'Provide your vehicle information so receivers know what to look for when you arrive.'} placeholder={'Make'} changeHandler = {this.getInputValue} dollar={false} for='offerData.car.make' />
          <InputComponent value = { (offerData && validate.isEmpty(this.state.offerData.car) )? "" : this.state.offerData.car.model} type={'text'} title={''} placeholder={'Model'} changeHandler = {this.getInputValue} dollar={false} for='offerData.car.model' />
          <InputComponent value = { (offerData && validate.isEmpty(this.state.offerData.car) )? "" : this.state.offerData.car.color} type={'text'} title={''} placeholder={'Color'} changeHandler = {this.getInputValue} dollar={false} for='offerData.car.color' />
        </div>
       <button id="deliveryDetails" className="btn orange" onClick={this.addTransportationDetails}>Next</button>
     </div>
   )
 }
}

class DeliveryComponentPulicTransit extends React.Component{
 constructor(props){
   super(props);
   this.state = {
     offerData: this.props.offerData,
     error: ''
   }
 }

 componentWillReceiveProps(newProps){

   this.setState({
     offerData: newProps.offerData
   })

 }

 addTransportationDetails = () => {

   let validationErrorMsg = '';
   let validationError;
   let validationMap;
   const {state} = this;
   let offerDataState = this.state.offerData;

   const offerData = Object.assign({}, offerDataState);

   if(!offerData.hasOwnProperty('public')){
     offerData.public = null;
   }

   validationError = {
     publicTransitInfo: !validate.name(offerData.publicTransitInfo)
   };

   validationMap = {
     publicTransitInfo: 'Public Trasport details'
   };

   const validationFields = [];

   Object.keys(validationError).forEach((key) => {
       if (validationError[key]) {
           validationFields.push(validationMap[key]);
       }
   });

   if (validationFields.length) {
       validationErrorMsg = 'Please enter the ' + join(validationFields, (item, idx) => {
           if (validationFields.length === 1)
               return "";
           if (idx > 0 && idx < validationFields.length - 1)
               return ", ";
           else if (idx === validationFields.length - 1)
               return " and ";
           return "";
       }) + '.';
   }

   if (validationErrorMsg) {
       this.setState({error: validationErrorMsg},
         this.props.updateParentState(state.offerData, validationErrorMsg)
       );
       return;
   }else{
       this.props.updateParentState(state.offerData, null);
   }

 }

 componentDidMount(){
   const offerData = Object.assign({}, this.props.offerData);
   if(!offerData.hasOwnProperty('public')){
     offerData.public = null;
     this.setState({
       offerData
     })
   }
 }

 getInputValue = (inputName, value) => {

   let inputArr = inputName.split('.');
   let offerData = Object.assign({},this.state.offerData);
   let car = {};
   ( validate.isEmpty(offerData.car) ? car = offerData.car : (car = car) );

   if(inputArr[1] == 'car'){
     offerData.car[inputArr[2]] = value;
   }else{
     offerData[inputArr[1]] = value;
   }

   this.setState({
     offerData
   })

 }

 render(){
   return(
     <div>
       <div className="transporation-form">
         <InputComponent value={validate.isEmpty(this.state.offerData) ? "" : this.state.offerData.publicTransitInfo} type={'text'} title={'Provide your public transit info so that receivers know how you’ll be arriving.'} placeholder={'Bus, train or subway info'} changeHandler = {this.getInputValue} dollar={false} for='offerData.publicTransitInfo' />
       </div>
       <button id="deliveryDetails" className="btn orange" onClick={this.addTransportationDetails}>Next</button>
     </div>
   )
 }
}


class DeliveryData extends React.Component{
  constructor(props){
    super(props);
    let offerData = Object.assign({}, this.props.browsePackages.offerData)
    if(!offerData.hasOwnProperty('currTransport')){
      offerData.currTransport = 'flight';
    }
    if(offerData.currTransport == null || offerData.currTransport == undefined || offerData.currTransport == ''){
        offerData.currTransport = 'flight';
    }
    this.state = {
      offerData : offerData,
      error: '',
      popupActive: false
    }
  }
  componentDidMount(){
    let offerData = Object.assign({},this.state.offerData);
    if(!offerData.hasOwnProperty('car')){
      offerData.car = {}
      this.setState({
        offerData
      })
    }
  }
  componentWillReceiveProps(newProps){
    this.setState({
      offerData: newProps.browsePackages.offerData
    })
  }
  getInputValue = (inputName, value) => {

    let inputArr = inputName.split('.');

    let car = {};
    ( validate.isEmpty(offerData.car) ? car = offerData.car : (car = car) );

    if(inputArr[1] == 'car'){
      offerData.car[inputArr[2]] = value;
    }else{
      offerData[inputArr[1]] = value;
    }

    this.setState({
      offerData
    })

  }

  routeToPayPal = () => {
    let shipmentId =  commonFunctions.getShipmentId(this.props.location);
    browserHistory.push('/browse-shipments/paypal-details/' + shipmentId);
  }

  updateParentState = (offerData, error) => {
    if( offerData == null || offerData == undefined || offerData == ''){
      this.setState({
        error
      })
    }else if(error == null || error == undefined || error == ''){

      if(offerData.currTransport == 'flight'){

        if(offerData.hasOwnProperty('car')){
          offerData.car = {};
        }
        if(offerData.hasOwnProperty('publicTransitInfo')){
          offerData.publicTransitInfo = '';
        }

      }else if(offerData.currTransport == 'public'){

        if(offerData.hasOwnProperty('car')){
          offerData.car = {};
        }
        if(offerData.hasOwnProperty('flightNo')){
          offerData.flightNo = '';
        }
      }else{

        if(offerData.hasOwnProperty('flightNo')){
          offerData.flightNo = '';
        }
        if(offerData.hasOwnProperty('publicTransitInfo')){
          offerData.publicTransitInfo = '';
        }

      }
      this.setState({
        offerData
      }, this.props.browsePackagesAction.makeOffer(offerData), this.routeToPayPal() )

    }else{
      this.setState({
        offerData,
        error
      })
    }
  }

  setCurrTansport = (currTransport) => {
    let offerData = Object.assign({}, this.state.offerData);
    offerData.currTransport = currTransport;
    this.setState({
      offerData,
      error: ''
    })
  }

  openPopup = () =>{
    this.setState({popupActive: true});
  }

  closePopup = ()=>{
    this.setState({popupActive: false});
  }

  render(){
    const self = this;
    const {props, state} = this;
    let offerData = this.state.offerData;
    let currTransport = this.state.offerData.currTransport;
    let shipmentId = commonFunctions.getShipmentId(this.props.location);
    commonFunctions.validateOfferData(props.browsePackages ,props.location);
    let url = '/browse-shipments/send-message/' + shipmentId;

    const shipmentDetails = this.props.shipment.shipmentDetails;
    const {userData} = this.props.authState;

    if(shipmentDetails.shipmentType===2){
      let transportType = "FLIGHT";
      if(currTransport==="car") transportType = "CAR";
      else if(currTransport==="public") transportType = "PUBLIC TRANSPORT";

      if(userData.email) amplitude.getInstance().setUserId(userData.email);
      amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.ITEM_REQ_DELIVERY_MODE,{transportType: transportType});
    }

    return(
      <div>
        <div id="deliveryDataWrap" className="wrapper">
          <Link to={url}>
            <div className="back-section"><span className="icon-icn_back"></span><span className="back-content">Back</span></div>
          </Link>
          <div className="delivery-data-wrap">
            <MediaQuery query='(min-width: 768px)'>
              <div className="shipment-details">
                <ShipmentDetailsSection shipmentId={shipmentId} />
              </div>
            </MediaQuery>

            <div className="delivery-details">
              {this.state.error && <ShowError errorMessage = {this.state.error} />}
              <div id="deliveryDetailsHeader">How are you delivering the package?</div>
              <div className="delivery-type-select">
                <div className = "transportation-objects-wrap" onClick={this.setCurrTansport.bind(self, 'flight')}>
                  <div className= {"transportation-type" + (currTransport == 'flight' ? " transportation-selected" : "") } id="flightSemicircle"></div>
                  <div className= {"transportation-type" + (currTransport == 'flight' ? " transportation-selected" : "") } id="flight">Flight</div>
                </div>
                <div className = "transportation-objects-wrap" onClick={this.setCurrTansport.bind(self, 'car')}>
                  <div className= {"transportation-type" + (currTransport == 'car' ? " transportation-selected" : "") } id="car">Car</div>
                </div>
                <div className = "transportation-objects-wrap"  onClick={this.setCurrTansport.bind(self, 'public')}>
                    <div className= {"transportation-type" + (currTransport == 'public' ? " transportation-selected" : "") } id="publicTransit">Public Transit</div>
                    <div className= {"transportation-type" + (currTransport == 'public' ? " transportation-selected" : "") } id="publicTransitSemicircle"></div>
                </div>
                <div className="transporation-form-wrap">
                  { (currTransport == 'flight')  && <DeliveryComponentFlight offerData={this.state.offerData} updateParentState={this.updateParentState} /> }
                  { (currTransport == 'car')  && <DeliveryComponentCar offerData={this.state.offerData} updateParentState={this.updateParentState} /> }
                  { (currTransport == 'public')  && <DeliveryComponentPulicTransit offerData={this.state.offerData} updateParentState={this.updateParentState} /> }
                </div>
                {(currTransport == 'flight')  && <div className="flight-not-booked" onClick={this.openPopup}>I haven’t booked my flight yet</div>}
                {state.popupActive && <SendMessagePopup closePopupCallback={this.closePopup} />}
              </div>
            </div>

          </div>
        </div>
          <LoggedinFooter />
      </div>
    )
  }
}


DeliveryData = connect((state) => {
  return {
    authState: state.app.auth,
    shipment: state.app.shipment,
    browsePackages: state.app.browsePackages
  }
}, (dispatch) => {
  return {
    browsePackagesAction: bindActionCreators(browsePackagesAction, dispatch)
  }
})(DeliveryData);

export default DeliveryData;



// WEBPACK FOOTER //
// app/browse_packages/browse_delivery_method.jsx